import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)
const fufuyellow = '#f7ec96'
const fufugrey1 = '#b4acad'
const fufugrey2 = '#655e5e'
const bgColor = '#dad6d6'
export default new Vuetify({
  theme: {
    themes: {
      light: {
        bgColor,
        fufuyellow,
        fufugrey1,
        fufugrey2,
        secondary: '#f7ec96',
        primary: '#655e5e',
      },
    },
  },
})
